<template lang="pug">
.marketing-upload-contract-and-do(v-loading="loading")
  title-bar {{ $t('合同') }}
  .marketing-upload-contract-and-do_form(v-if="!contractResult")
    template(v-if="currentTask && currentTask.can_view")
      el-row
        el-col.required(:span="2") {{ $t('DO号') }}
        el-col(:span="20")
          span(v-if="isView") {{ contract.do_number }}
          el-input(v-model="contract.do_number" v-else)
      el-row
        el-col.required(:span="2") {{ $t('IO号') }}
        el-col(:span="20")
          .io_numbers(
            v-for="(item, i) in contract.io_numbers"
            :key="i"
          )
            template(
              v-if="isView"
            )
              span {{ contract.io_numbers[i] }}
            template(
              v-else
            )
              el-input(v-model="contract.io_numbers[i]")
              el-button(
                v-if="contract.io_numbers.length > 1"
                @click="contract.io_numbers.splice(i, 1)"
                type="text"
              ) {{ $t('删除') }}
          el-button(
            v-if="!isView"
            type="text"
            @click="contract.io_numbers.push('')"
          ) + {{ $t('添加IO号') }}
      el-row
        el-col.required(:span="2") {{ $t('合同号') }}
        el-col(:span="20")
          span(v-if="isView") {{ contract.contract_no }}
          el-input(v-model="contract.contract_no" v-else)
      el-row
        el-col.required(:span="2") {{ $t('合同') }}
        el-col(:span="20")
          .file_container
            new-upload-file(
              v-if="!isView"
              axiosUrl="/management/subfinal/saveFile"
              :params="uploadParams"
              @loadingChange="status => loading = status"
              @uploadSuccess="uploadSuccess"
            )
            a(
              v-if="contract.contract_download_path"
              :href="contract.contract_download_path"
              traget="_blank"
            ) {{ contract.contract_name }}
      el-row
        el-col(:offset="2" :span="10")
          footer-button(
            @confirm="submit"
            @cancel="$router.push('/unistar/campaign-overview')"
          )
    template(v-else)
      .no-data {{ $t('待确认') }}
  .info-display(v-else)
    el-row(:gutter="20")
      el-col(:span="24")
        .info_label {{ $t('DO号') }}
        .info_content {{ contractResult.campaign_contract.do_no }}
    el-row(:gutter="20")
      el-col(:span="24")
        .info_label {{ $t('IO号') }}
        .info_content
          div(v-for="(io, i) in contractResult.campaign_io" style="margin-top: 0") {{ io.io }}
    el-row(:gutter="20")
      el-col(:span="24")
        .info_label {{ $t('合同号') }}
        .info_content {{ contractResult.campaign_contract.contract_no }}
    el-row(:gutter="20")
      el-col(:span="24")
        .info_label {{ $t('合同') }}
        .info_content
          a(:href="contractResult.campaign_contract.download_url") {{ contractResult.campaign_contract.file_name }}
</template>

<script>
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import NewUploadFile from '@/components/NewUploadFile'
import axios from 'axios'
import { format4backend } from '@/umcc/util'
export default {
  data () {
    return {
      loading: false,
      contract: {
        do_number: '',
        io_numbers: [''],
        contract_name: '',
        contract_path: '',
        contract_download_path: '',
        contract_no: ''
      },
      contractResult: null
    }
  },
  components: {
    TitleBar,
    FooterButton,
    NewUploadFile
  },
  mounted () {
    this.getContranct()
  },
  methods: {
    submit () {
      if (!this.contract.do_number || !this.contract.contract_no || !this.contract.contract_path || this.contract.io_numbers.includes('')) {
        this.$message.error(this.$t('请填写必填项'))
        return
      }
      if (this.contract.do_number.length > 20 || this.contract.contract_no.length > 20 || this.contract.io_numbers.some(i => i.length > 20)) {
        this.$message.error(this.$t('DO号/合同号长度超出限制'))
        return
      }
      let params = {
        campaign_id: this.campaignId,
        servlet_path: this.$route.path,
        task_id: this.currentTask.taskId,
        campaign_contract: {
          do_no: this.contract.do_number,
          contract_no: this.contract.contract_no,
          contract_path: this.contract.contract_path
        },
        campaign_io: this.contract.io_numbers.map(num => {
          return {
            io: num
          }
        })
      }
      this.loading = true
      axios.post('/management/star/saveCampaignContract', format4backend(params))
        .then(res => {
          this.$store.dispatch('unistar/getCampaignInfo')
          this.$store.dispatch('unistar/getProcessTasks', {
            business_key: this.campaignId,
            business_type: this.currentTask.business_type,
            phase_type: 1
          })
          this.getContranct()
          this.$message.success(this.$t('提交成功'))
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    uploadSuccess (res) {
      this.contract.contract_path = res.file_path
      this.contract.contract_name = res.file_name
      this.contract.contract_download_path = res.file_download_path
      this.loading = false
    },
    getContranct () {
      axios.get('/management/star/getCampaignContract', {
        params: {
          campaign_id: this.campaignId
        }
      }).then(res => {
        this.loading = false
        if (res.campaign_contract) {
          this.contractResult = res
        }
      })
    }
  },
  computed: {
    campaignId () {
      return this.$store.state.unistar.campaignInfo.campaign_id
    },
    uploadParams () {
      return {
        campaign_id: this.campaignId,
        file_type: 4
      }
    },
    currentTask () {
      return this.$store.state.unistar.sowProcess.find(task => this.$route.path.includes(task.action))
    },
    sowInfo () {
      return this.$store.state.unistar.sowInfo
    }
  }
}
</script>

<style lang="stylus">
.marketing-upload-contract-and-do
  .marketing-upload-contract-and-do_form
    .no-data
      height 300px
      display flex
      justify-content center
      align-items center
      font-size 30px
      color #e0e0e0
    .io_numbers
      margin-bottom 10px
      .el-button
        margin-left 5px
    .el-input
      width 200px
    .file_container
      display flex
      align-items center
      a
        margin-left 15px
</style>
